import { Controller } from 'stimulus';

// Renders the response-time chart's layer toggles in the page shell, inline
// with the heading that sits outside the chart's turbo frame, and drives the
// in-frame chart via window events. Owns the toggle state and the "keep at
// least one layer visible" rule so the chart just applies what it's told.
// Re-broadcasts when the chart announces it is ready, so a (re)loaded frame
// picks up the current selection.
export default class extends Controller {
  static targets = ['toggle'];
  static values = { frame: String };

  connect() {
    this.visibleLayers = new Set(
      this.toggleTargets
        .filter((toggle) => toggle.getAttribute('aria-pressed') === 'true')
        .map((toggle) => toggle.dataset.layer)
    );
    this.onChartReady = this.onChartReady.bind(this);
    window.addEventListener('response-time-chart:ready', this.onChartReady);
  }

  disconnect() {
    window.removeEventListener('response-time-chart:ready', this.onChartReady);
  }

  toggle(event) {
    const button = event.currentTarget;
    const layer = button.dataset.layer;
    const active = this.visibleLayers.has(layer);
    if (active && this.visibleLayers.size === 1) return;

    if (active) this.visibleLayers.delete(layer);
    else this.visibleLayers.add(layer);

    button.classList.toggle('active', !active);
    button.setAttribute('aria-pressed', String(!active));
    this.broadcast();
  }

  onChartReady(event) {
    if (event.detail?.frame !== this.frameValue) return;
    this.broadcast();
  }

  broadcast() {
    window.dispatchEvent(
      new CustomEvent('response-time-chart:set-layers', {
        detail: { frame: this.frameValue, layers: [...this.visibleLayers] },
      })
    );
  }
}
